export const HOME_ROUTE = "/";
export const INFO_HOME_ROUTE = `/info`;
export const TASK_HOME_ROUTE = `/tasks`;
export const ADMIN_HOME_ROUTE = `/admin`;
export const SUPER_ADMIN_DASHBOARD_ROUTE = `/admin/super-dashboard`;